export const VENUS_VIP_TELEGRAM_URL = 'https://t.me/venuslabsvip';
export const VIP_PORTFOLIO_THRESHOLD_CENTS = 800_000_000; // $800k
